import { lazy } from 'react';

// Route-level code splitting: each page is its own download, fetched the first
// time someone visits it, instead of every page shipping in the main bundle.
//
// After a deploy the old page files are gone, so a visitor who had the site
// open can hit "Loading chunk failed" on their next click. Reload once to pick
// up the new version; if it still fails, let the error surface normally.
const RELOADED_KEY = 'cst_chunk_reload';

export default function lazyPage(importer) {
  return lazy(() => importer().then(
    mod => {
      try { sessionStorage.removeItem(RELOADED_KEY); } catch { /* storage blocked */ }
      return mod;
    },
    err => {
      let already = false;
      try { already = sessionStorage.getItem(RELOADED_KEY) === '1'; } catch { /* storage blocked */ }
      if (!already && /chunk|dynamically imported module|Importing a module script failed/i.test(String(err && err.message))) {
        try { sessionStorage.setItem(RELOADED_KEY, '1'); } catch { /* storage blocked */ }
        window.location.reload();
        return new Promise(() => {}); // page is reloading
      }
      throw err;
    },
  ));
}
